import { render, staticRenderFns } from "./IdentificacaoFilter.vue?vue&type=template&id=69be11b6"
import script from "./IdentificacaoFilter.vue?vue&type=script&lang=js"
export * from "./IdentificacaoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports